<div class="step-layout !mx-auto !flex !w-full !flex-col !gap-8">
    <header class="!flex !flex-col !gap-2">
        <p class="!mb-0 !text-xs !font-bold !uppercase !tracking-[0.08em] !text-primary">Passo 7 di 8</p>
        <h2 class="!mb-0 !text-[clamp(1.75rem,3vw,2.25rem)] !font-extrabold !leading-tight !text-strong">
            Verifica la tua <span class="gradient-text">email</span>
        </h2>
        <p class="!mb-0 !max-w-xl !text-base !leading-relaxed !text-subtle">
            Conferma l'indirizzo email del manager prima di procedere al pagamento.
        </p>
    </header>

    <section class="!overflow-visible !rounded-2xl !border !border-solid !border-border !bg-white !p-6 md:!p-8"
             aria-labelledby="otp-card-title">
        <div class="!mb-5 !border-b !border-solid !border-slate-100 !pb-5">
            <h3 id="otp-card-title" class="!mb-1 !text-base !font-bold !text-strong">Codice di verifica</h3>
            <p class="!mb-3 !text-sm !leading-snug !text-subtle">
                Abbiamo inviato un codice di 6 caratteri a
            </p>
            <p class="!mb-0 !inline-flex !max-w-full !items-center !gap-2 !rounded-full !bg-slate-100 !px-3 !py-1.5 !text-sm !font-bold !text-slate-700">
                <i class="bi bi-envelope !text-slate-400" aria-hidden="true"></i>
                <span class="!break-all">{{ company.legalEmail }}</span>
            </p>
        </div>

        <div class="!flex !flex-col !items-center !gap-4">
            <div class="!relative !flex !flex-wrap !justify-center !gap-2 sm:!gap-2.5" role="group" aria-label="Codice OTP">
                <input type="text"
                       name="one-time-code"
                       autocomplete="one-time-code"
                       inputmode="text"
                       maxlength="6"
                       autocapitalize="characters"
                       spellcheck="false"
                       tabindex="-1"
                       aria-hidden="true"
                       class="otp-autofill-input"
                       (input)="onAutofillInput($event)">
                <input *ngFor="let index of otpIndexes"
                       #otpSlot
                       type="text"
                       inputmode="text"
                       [attr.maxlength]="index === 0 ? 6 : 1"
                       [attr.autocomplete]="index === 0 ? 'one-time-code' : 'off'"
                       autocapitalize="characters"
                       spellcheck="false"
                       class="form-control !box-border !h-14 !w-11 !rounded-xl !border !border-solid !bg-white !p-0 !text-center !font-mono !text-xl !font-bold !uppercase !text-slate-900 !shadow-none focus:!border-primary focus:!bg-white focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)] sm:!h-16 sm:!w-12 sm:!text-2xl"
                       [ngClass]="otpCharAt(index) ? '!border-primary' : '!border-slate-200'"
                       [class.is-invalid]="submitted && !isOtpComplete"
                       [value]="otpCharAt(index)"
                       (beforeinput)="onBeforeInput(index, $event)"
                       (input)="onSlotInput(index, $event)"
                       (keydown)="onSlotKeydown(index, $event)"
                       (paste)="onOtpPaste($event)"
                       (focus)="onSlotFocus($event)">
            </div>
            <p class="!mb-0 !text-center !text-xs !leading-relaxed !text-slate-400">
                Il codice può contenere lettere e numeri. Controlla anche la cartella spam.
            </p>
            <p class="!mb-0 !text-sm !text-red-600" *ngIf="submitted && !isOtpComplete">
                Inserisci i 6 caratteri del codice per continuare.
            </p>
        </div>

        <div class="!mt-6 !rounded-xl !bg-slate-50 !px-4 !py-3 !text-center">
            <p *ngIf="showOtpResendCountdown" class="!mb-0 !text-sm !text-slate-500" aria-live="polite">
                Potrai richiedere un nuovo codice tra
                <strong class="!tabular-nums !text-slate-700">{{ otpResendSecondsLeft }} secondi</strong>.
            </p>
            <button *ngIf="showResendOtpButton" type="button"
                    class="!inline-flex !items-center !justify-center !gap-2 !border-0 !bg-transparent !p-0 !text-sm !font-bold !text-primary hover:!underline disabled:!cursor-not-allowed disabled:!opacity-60"
                    [disabled]="isResendingOtp" (click)="resendOtp()">
                <span *ngIf="isResendingOtp" class="spinner-border spinner-border-sm" role="status"></span>
                <i *ngIf="!isResendingOtp" class="bi bi-arrow-clockwise" aria-hidden="true"></i>
                {{ isResendingOtp ? 'Invio in corso...' : 'Invia un nuovo codice' }}
            </button>
            <p *ngIf="!showOtpResendCountdown && !showResendOtpButton" class="!mb-0 !text-sm !text-slate-500">
                Il codice si verifica automaticamente quando è completo.
            </p>
        </div>
    </section>

    <div class="step-actions">
        <button type="button" class="btn-back" (click)="!isProcessing && previousStep()"
                [class.btn-back--disabled]="isProcessing">Indietro</button>
        <button type="button" class="btn-procedi" [disabled]="isProcessing" (click)="checkOTP()">
            <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-2" role="status"></span>
            {{ isProcessing ? 'Verifica in corso...' : 'Verifica e continua' }}
        </button>
    </div>
</div>
